import { Site } from '@/common/const'
import { t } from '@/plugins/i18n'

export const tipList:any = {
  oemStatus: {
    name: 'oemStatus',
    title: t('春节前纳品oem商品截单日'),
    // 开始时间
    startTime: '2024/12/24 00:00:00',
    // 结束时间
    endTime: '2025/01/15 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 1,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: t('服装杂货'),
        time: t('★12/25（水）')
      },
      {
        title: t('辅料（纸盒，特殊纸袋，opp袋）'),
        time: t('★1/5（日）')
      },
      {
        title: t('辅料（布标，纸标，说明书）'),
        time: t('★1/15（水）')
      }
    ],
    text: [
      {
        text: t('oem订单请尽快下单！')
      },
      {
        text: t('※oem工厂春节休息时间：约1月初~2月中旬')
      },
      {
        text: t('※截单日之后也可以下单，但是工厂发货基本会延迟到2月下旬及以后~2月中旬')
      },
      {
        text: t('※每个工厂的情况不同，截单日之前的订单也会有春节后发货的可能性')
      }
    ]
  },
  stopPurchase: {
    name: 'stopPurchase',
    title: t('成品采购春节停止下单时间'),
    // 开始时间
    startTime: '2024/12/24 00:00:00',
    // 结束时间
    endTime: '2025/01/21 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: '',
        time: t('１月２２日（水）~２月４日（火）')
      }
    ],
    text: [
      {
        text: t('建议春节前尽快囤货')
      },
      {
        text: t('※由于部分店铺已经开始休业，1月22日之前下单的商品也有节前发不出货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认')
      },
      {
        text: t('※１月２２日（水）~２月４日（火）的订单我们也受理，统一在2月4日之后采购')
      }
    ]
  },
  expressTime: {
    name: 'expressTime',
    title: t('春节前希望发货的发货委托制作的推荐期间'),
    // 开始时间
    startTime: '2025/01/05 00:00:00',
    // 结束时间
    endTime: '2025/01/24 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: t('船运节前出货发货依赖截单时间'),
        time: t('1月20日（月）18时')
      },
      {
        title: t('空运节前出货发货依赖截单时间'),
        time: t('1月24日（金）12时')
      }
    ],
    text: [
      {
        text: t('请提前安排发货')
      }
    ]
  },
  marketPurchase: {
    name: 'marketPurchase',
    title: t('市场购春节停止拿货时间'),
    // 开始时间
    startTime: '2025/01/01 00:00:00',
    // 结束时间
    endTime: '2025/02/04 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: '',
        time: t('1月18日（土）~2月4日（火）')
      }
    ],
    text: [
      {
        text: t('市场购商品请在1月27日之前囤货')
      },
      {
        text: t('※由于部分市场已经开始休业，1月18日之前下单的市场购商品也有拿不到货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认')
      },
      {
        text: t('※1月18日（金）~2月4日（火）休的市场购订单，统一在2月4日之后拿货')
      }
    ]
  },
  oemSendCreate: {
    name: 'oemSendCreate',
    title: t('（注文，寻源）工厂停止生产'),
    // 开始时间
    startTime: '2025/01/16 00:00:00',
    // 结束时间
    endTime: '2025/02/04 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 1,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: '',
        time: t('1月16日（水）~2月4日（火）休')
      }
    ],
    text: [
      {
        text: t('由于OEM商家基本已经开始休业，1月16日（水）~2月4日（火）休的oem寻源和订单，基本会在2月4日之后出货')
      },
      {
        text: t('承接订单，提前咨询，提前沟通，锁定库存，准备材料')
      },
      {
        text: t('商家提前排期，先下单先出货')
      }
    ]
  },
  stopPurchaseOrder: {
    name: 'stopPurchaseOrder',
    title: t('成品订单 停止采购！'),
    // 开始时间
    startTime: '2025/01/22 00:00:00',
    // 结束时间
    endTime: '2025/02/04 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: '',
        time: t('１月２２日（水）~２月４日（火）')
      }
    ],
    text: [
      {
        text: t('※由于商家已经开始休业，１月２２日（水）~２月４日（火）的订单，统一在2月4日之后采购。')
      },
      {
        text: t('※由于商家恢复营业的时间不同，2月4日营业再开后，部分商品也有可能在2月中旬才能发货，请谅解')
      },
      {
        text: t('不能采购，但是承接订单，提前咨询，提前沟通，锁定库存')
      }
    ]
  },
  stopWarehouse: {
    name: 'stopWarehouse',
    title: t('直行便仓库休息时间'),
    // 开始时间
    startTime: '2025/01/27 00:00:00',
    // 结束时间
    endTime: '2025/02/04 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: t('D2C（仓库发货停止）'),
        time: t('1月28日（火）~2月2日（日）')
      },
      {
        title: t('B2B（仓库发货停止）'),
        time: t('1月27日（水）~2月4日（火）')
      }
    ],
    text: [
      {
        text: t('发货依赖正常受理，节后顺次发货')
      },
      {
        text: t('订单正常受理，采购和发货在2月中旬顺时恢复')
      }
    ]
  }
}
